/* Size guide — shared behaviour (no framework, no imports).
 * 1. cm/inch unit toggle, via event delegation, for any [data-unit] container.
 * 2. PDP size-guide modal: open / close / tab switching, with focus + Escape.
 * Loaded once; guarded so multiple hosts don't double-bind. */
(function () {
  if (window.__stbSizeGuide) return;
  window.__stbSizeGuide = true;

  var lastTrigger = null;

  document.addEventListener('click', function (event) {
    // ---- Unit toggle (cm / inch) ----
    var unitBtn = event.target.closest('[data-unit-set]');
    if (unitBtn) {
      var scope = unitBtn.closest('[data-unit]');
      if (scope) {
        scope.setAttribute('data-unit', unitBtn.getAttribute('data-unit-set'));
        scope.querySelectorAll('[data-unit-set]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === unitBtn ? 'true' : 'false');
        });
      }
      return;
    }

    // ---- Open modal ----
    var opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-size-guide-open'));
      if (modal) {
        lastTrigger = opener;
        openModal(modal);
      }
      return;
    }

    // ---- Close modal (close button or overlay backdrop) ----
    var closer = event.target.closest('[data-size-guide-close]');
    var backdrop = event.target.matches('.size-guide-modal') ? event.target : null;
    if (closer || backdrop) {
      var open = (closer && closer.closest('.size-guide-modal')) || backdrop;
      if (open) closeModal(open);
      return;
    }

    // ---- Tab switching ----
    var tab = event.target.closest('[data-size-guide-tab]');
    if (tab) {
      var root = tab.closest('.size-guide-modal');
      if (!root) return;
      var name = tab.getAttribute('data-size-guide-tab');
      root.querySelectorAll('[data-size-guide-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      root.querySelectorAll('[data-size-guide-pane]').forEach(function (p) {
        p.hidden = p.getAttribute('data-size-guide-pane') !== name;
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.size-guide-modal:not([hidden])');
    if (open) closeModal(open);
  });

  function openModal(modal) {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var focusable = modal.querySelector('[data-size-guide-close], button, a[href]');
    if (focusable) focusable.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }
})();
